














import Vue from 'vue'
import EmptyPaket from '@/app/ui/assets/EmptyState/no_data-paket.vue'
import PostedIcon from '@/app/ui/assets/posted_icon.vue'
import SearchNotFoundIcon from '@/app/ui/assets/search_not_found_icon.vue'
import IllustrationEmptyState from '@/app/ui/assets/ill_spot_miscellaneous.vue'
import IllustrationProofDelivery from '@/app/ui/assets/ill_spot_proof_delivery.vue'

export default Vue.extend({
  name: 'EmptyState',
  components:{
    EmptyPaket,
    PostedIcon,
    SearchNotFoundIcon,
    IllustrationEmptyState,
    IllustrationProofDelivery
  },
  props: {
    type: {
      type: String,
      default: 'empty',
    },
    text: {
      type: String,
      default: '',
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    customClass: {
      type: String,
      default: '',
    },
    classText: {
      type: String,
      default: '',
    },
    classDesc: {
      type: String,
      default: '',
    },
  },
  data: () => {
    return {}
  },
  methods: {},
})
